import { render } from "./SystemFooter.vue?vue&type=template&id=2360ac35&scoped=true"
import script from "./SystemFooter.vue?vue&type=script&lang=js"
export * from "./SystemFooter.vue?vue&type=script&lang=js"

import "./SystemFooter.vue?vue&type=style&index=0&id=2360ac35&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2360ac35"]])

export default __exports__